/* Routing */
import {Link, useNavigate} from "react-router-dom";
/* Contexts */
import useDeceased from "../../../hooks/useDeceased";
import useData from "../../../hooks/useData";
/* Resources */
import useAuth from "../../../hooks/useAuth";
import usePager from "../../../hooks/usePager";
/* API */
import {deleteUser, setUserEnabled, switchUser} from "../../../api/admin/userReq";
import {deleteAgencyFromDB, setAgencyEnabled} from "../../../api/admin/agencyReq";
import {deleteActivityFromDB, setActivityEnabled} from "../../../api/admin/activityReq";
import {deleteEstimateLine, updateLineStatus} from "../../../api/admin/estimateReq";
import {deleteDocumentFromDb, updateDocumentEnable} from "../../../api/admin/documentReq";
import {deleteNetworkFromDb, updateNetworkStatus} from "../../../api/admin/networkReq";
import {deleteDeceasedFromDb} from "../../../api/pro/deceasedReq";
import TiptapView from "../input-layout/tiptap/TiptapView";
import {deleteCadFromDb, setCADEnabled} from "../../../api/admin/cadReq";
import {setDeceasedEnabled} from "../../../api/pro/deceasedReq";
import {safeJwtDecode} from "../../../helper/jwtHelper";
import {getErrorListFromValidation, removeErrorList, capitalize} from "../../../helper/tools";

export default function DashboardLine( {
    deleted,
    tab,
    location,
    line,
    thIndexes,
    isSelected,
    agenciesApi,
    apiUserList,
    activitiesApi,
    documentsApi,
    apiCADList,
    apiNetworkList,
    deceasedListApi,
    apiEstimateTemplateList,
} ) {
    const { setDeceased } = useDeceased();
    const { setData, documentList } = useData();
    const { auth, setAuth } = useAuth();
    const { currentPage, setCurrentPage } = usePager();
    const token = auth.token;
    const navigate = useNavigate();
    const handleClick = (e) => {
        (location === "Tableau de bord" || location === "Défunts")
            ? setDeceased(line)
            : setData(line)
    };

    const handleChangeUserEnabled = async (e) => {
        e.preventDefault();
        if (!auth.roles.includes("ROLE_BACKEND")) {
            alert("Vous n'avez pas les droits pour modifier la visibilité d'un utilisateur.");
        } else {
            const userId = parseInt(e.currentTarget.getAttribute("id"));
            const currentIsEnabled = e.currentTarget.classList.contains("fa-eye");

            if (currentIsEnabled) {
                let body = {
                    "userEnabled": false,
                    "userId": userId,
                }
                alert("Vous venez de désactiver cet utilisateur.");
                await setUserEnabled(token, body)
                    .then((response) => {
                            removeErrorList();
                            if (!response?.response?.data?.error) {
                                apiUserList()
                            } else {
                                getErrorListFromValidation(response?.response?.data?.error)
                            }
                    })
            } else {
                let body = {
                    "userEnabled": true,
                    "userId": userId,
                }
                alert("Vous venez d'activer cet utilisateur.");
                await setUserEnabled(token, body)
                    .then((response) => {
                            removeErrorList();
                            if (!response?.response?.data?.error) {
                                apiUserList()
                            } else {
                                getErrorListFromValidation(response?.response?.data?.error)
                            }
                    })
            }
        }
    };

    const handleChangeActivityEnabled = (e) => {
        e.preventDefault();
        if (!auth.roles.includes("ROLE_BACKEND")) {
            alert("Vous n'avez pas les droits pour modifier la visibilité d'une activité.");
        } else {
            const activityId = parseInt(e.currentTarget.getAttribute("id"));
            const currentIsEnabled = e.currentTarget.classList.contains("fa-eye");

            if (currentIsEnabled) {
                let body = {
                    "activityId": activityId,
                    "activityEnabled": false,
                }
                alert("Vous venez de désactiver cette activité.");
                setActivityEnabled(token, body)
                    .then((response) => {
                        removeErrorList();
                        if (!response?.response?.data?.error) {
                            activitiesApi()
                        } else {
                            getErrorListFromValidation(response?.response?.data?.error)
                        }
                    })
            } else {
                let body = {
                    "activityId": activityId,
                    "activityEnabled": true,
                }
                alert("Vous venez d'activer cette activité.");
                setActivityEnabled(token, body)
                    .then((response) => {
                        removeErrorList();
                        if (!response?.response?.data?.error) {
                            activitiesApi()
                        } else {
                            getErrorListFromValidation(response?.response?.data?.error)
                        }
                    })
            }
        }
    };

    const handleAgencyEnable = async (e) => {
        e.preventDefault();
        if (!auth.roles.includes("ROLE_BACKEND")) {
            alert("Vous n'avez pas les droits pour modifier la visibilité d'une agence.");
        } else {
            const agencyId = parseInt(e.currentTarget.getAttribute("id"));
            const currentIsEnabled = e.currentTarget.classList.contains("fa-eye");

            if (currentIsEnabled) {
                let body = {
                    "agencyEnabled": false,
                    "agencyId": agencyId,
                }
                alert("Vous venez de désactiver cette agence.");
                await setAgencyEnabled(token, body)
                    .then((response) => {
                        removeErrorList();
                        if (!response?.response?.data?.error) {
                            agenciesApi()
                        } else {
                            getErrorListFromValidation(response?.response?.data?.error)
                        }
                    })
            } else {
                let body = {
                    "agencyEnabled": true,
                    "agencyId": agencyId,
                }
                alert("Vous venez d'activer cette agence.");
                await setAgencyEnabled(token, body)
                    .then((response) => {
                        removeErrorList();
                        if (!response?.response?.data?.error) {
                            agenciesApi()
                        } else {
                            getErrorListFromValidation(response?.response?.data?.error)
                        }
                    })
            }
        }
    };
    const handleDocumentEnable = async (e) => {
        e.preventDefault();
        if (!auth.roles.includes("ROLE_BACKEND")) {
            alert("Vous n'avez pas les droits pour modifier la visibilité d'un document.");
        } else {
            const documentId = parseInt(e.currentTarget.getAttribute("id"));
            const currentIsEnabled = e.currentTarget.classList.contains("fa-eye");

            if (currentIsEnabled) {
                let body = {
                    "documentEnabled": false,
                    "documentId": documentId,
                }
                await updateDocumentEnable(token, body)
                    .then((response) => {
                        removeErrorList();
                        if (!response?.response?.data?.error) {
                            documentsApi()
                        } else {
                            getErrorListFromValidation(response?.response?.data?.error)
                        }
                    })
            } else {
                let body = {
                    "documentEnabled": true,
                    "documentId": documentId,
                }
                await updateDocumentEnable(token, body)
                    .then((response) => {
                        removeErrorList();
                        if (!response?.response?.data?.error) {
                            documentsApi()
                        } else {
                            getErrorListFromValidation(response?.response?.data?.error)
                        }
                    })
            }
        }
    }

    const handleDeleteAgency = async (e) => {
        e.preventDefault();
        const id = e.currentTarget.getAttribute("id");
        if (!auth.roles.includes("ROLE_BACKEND")) {
            alert("Vous n'avez pas les droits pour supprimer définitivement une agence.");
        } else {
            if (window.confirm("Êtes-vous sûr de vouloir supprimer définitivement cette agence? Tous les défunts ainsi que les données de facturation et les produits rattachés à l'agence  vont également être supprimés.")) {
                const body = {
                    "agencyId": parseInt(id),
                }
                deleteAgencyFromDB(token, body)
                agenciesApi()
            }
        }
    }

    const handleDeleteUser = async (e) => {
        e.preventDefault();
        const id = e.currentTarget.getAttribute("id");
        if (!auth.roles.includes("ROLE_BACKEND")) {
            alert("Vous n'avez pas les droits pour supprimer définitivement un utilisateur.");
        } else {
            if (window.confirm("Êtes-vous sûr de vouloir supprimer définitivement cet utilisateur ?")) {
                const body = {
                    "userId": id
                }
                await deleteUser(token, body)
                apiUserList()
            }
        }
    }

    const handleSwitchUser = async (userName) => {
        try {
            const response = await switchUser(token, userName);

            if (response?.response?.status) {
                console.error("Erreur HTTP lors de l'impersonate:", response.response.status, response.response.data);
                alert(`Erreur ${response.response.status}: ${response.response.data?.message || 'Impossible de se connecter en tant que cet utilisateur'}`);
                return;
            }

            if (!response || !response.token || !response.refresh_token) {
                console.error("Réponse invalide lors de l'impersonate:", response);
                alert("Impossible de se connecter en tant que cet utilisateur. Vérifiez que l'utilisateur est bien actif et que vous avez les droits nécessaires.");
                return;
            }

            localStorage.setItem("old_refresh_token", localStorage.getItem("refresh_token"));
            localStorage.setItem("impersonate_return_page", currentPage.toString());

            localStorage.setItem("refresh_token", response.refresh_token);
            localStorage.setItem("persist", "true");

            // Décoder le token pour extraire toutes les informations
            const decodedToken = safeJwtDecode(response.token);

            const roles = decodedToken?.roles;
            const authData = {
                username: decodedToken?.username,
                roles,
                token: response.token,
                agency: decodedToken?.agency,
                agency_logo: decodedToken?.agency_logo,
                network: decodedToken?.network
            };

            setAuth(authData);
            await new Promise(resolve => setTimeout(resolve, 200));
            window.location.href = '/';
        } catch (error) {
            console.error("Exception lors de l'impersonate:", error);
            alert(`Erreur lors de la connexion en tant que ${userName}: ${error.message || 'Erreur inconnue'}`);
        }
    }

    const handleDeleteActivity = async (e) => {
        e.preventDefault();
        const id = e.currentTarget.getAttribute("id");
        if (!auth.roles.includes("ROLE_BACKEND")) {
            alert("Vous n'avez pas les droits pour supprimer définitivement une activité.");
        } else {
            if (window.confirm("Êtes-vous sûr de vouloir supprimer définitivement cette activité ?")) {
                const body = {
                    "activityId": parseInt(id),
                }
               await deleteActivityFromDB(token, body)
                    .then((response) => {
                        response.error ? alert("L'activité n'a pas pu être supprimée.") : alert("L'activité a bien été supprimée.")
                    })
               activitiesApi()
            }
        }
    }

    const handleDeleteDocument = async (e) => {
        e.preventDefault();
        const id = e.currentTarget.getAttribute("id");
        if (!auth.roles.includes("ROLE_BACKEND")) {
            alert("Vous n'avez pas les droits pour supprimer définitivement un document.");
        } else {
            if (window.confirm("Êtes-vous sûr de vouloir supprimer définitivement ce document ?")) {
                const body = {
                    "documentId": parseInt(id),
                }
                await deleteDocumentFromDb(token, body)
                    .then((response) => {
                        response.error ? alert("Le document n'a pas pu être supprimé.") : alert("Le document a bien été supprimé.")

                        // Si c'était le dernier document de la page et qu'on n'est pas sur la première page
                        if (documentList?.length === 1 && currentPage > 1) {
                            setCurrentPage(currentPage - 1);
                        }
                })
                documentsApi()
            }
        }
    }

    const handleDeleteEstimateLine = async (e) => {
        e.preventDefault();
        const id = e.currentTarget.getAttribute("id");
        const line = e.currentTarget.getAttribute("line");
        if (!auth.roles.includes("ROLE_BACKEND")) {
            alert("Vous n'avez pas les droits pour supprimer une ligne de devis.");
        } else {
            if (window.confirm(`Êtes-vous sûr de vouloir supprimer définitivement la ligne ${line} du devis ?`)) {
                const body = {
                    "estimateLineId": parseInt(id),
                }

                await deleteEstimateLine(token, body)
                    .then((response) => (
                        response?.error ? alert("La ligne est utilisée dans un devis.") : ""
                    ))
                    apiEstimateTemplateList()
            }
        }
    }

    const handleEstimateLineEnable = async (e) => {
        e.preventDefault();
        if (!auth.roles.includes("ROLE_BACKEND")) {
            alert("Vous n'avez pas les droits pour modifier la visibilité d'une ligne.");
        } else {
            const templateId = parseInt(e.currentTarget.getAttribute("id"));
            const currentIsEnabled = e.currentTarget.classList.contains("fa-eye");

            if (currentIsEnabled) {
                let body = {
                    "lineEnabled": true,
                    "templateId": templateId,
                }
                alert("Vous venez de désactiver cette ligne.");
                await updateLineStatus(token, body)
            } else {
                let body = {
                    "lineEnabled": false,
                    "templateId": templateId,
                }
                alert("Vous venez d'activer cette ligne.");
                await updateLineStatus(token, body)

            }
        }
    };

    const handleChangeDeceasedEnabled = async (e) => {
        e.preventDefault();
        if (!auth.roles.includes("ROLE_PF" && "ROLE_UPF" && "ROLE_PREVIOUS_ADMIN")) {
            alert("Vous n'avez pas les droits pour modifier la visibilité d'un défunt.");
        } else {
            const deceasedId = parseInt(e.currentTarget.getAttribute("id"));
            const currentIsListed = e.currentTarget.classList.contains("fa-eye");

            if (currentIsListed) {
                let body = {
                    "deceasedEnabled": true,
                    "deceasedId": deceasedId,
                }
                alert("Vous venez de rendre invisible ce défunt.");
                await setDeceasedEnabled(token, body)
                    .then((response) => {
                        removeErrorList();
                        if (!response?.response?.data?.error) {
                            deceasedListApi()
                        } else {
                            getErrorListFromValidation(response?.response?.data?.error)
                        }
                    })
            } else {
                let body = {
                    "deceasedEnabled": false,
                    "deceasedId": deceasedId,
                }
                alert("Vous venez de rendre visible ce défunt.");
                await setDeceasedEnabled(token, body)
                    .then((response) => {
                        removeErrorList();
                        if (!response?.response?.data?.error) {
                            deceasedListApi()
                        } else {
                            getErrorListFromValidation(response?.response?.data?.error)
                        }
                    })
            }
        }
    };

    const handleCadExpressEnable = async (e) => {
        e.preventDefault();
        if (!auth.roles.includes("ROLE_BACKEND")) {
            alert("Vous n'avez pas les droits pour modifier la visibilité d'un courrier.");
        } else {
            const cadId = e.currentTarget.getAttribute("id");
            const currentIsEnabled = e.currentTarget.classList.contains("fa-eye");

            if (currentIsEnabled) {
                let body = {
                    "cadEnabled": true,
                    "cadId": cadId,
                }
                alert("Vous venez de désactiver ce courrier.");
                await setCADEnabled(token, body)
                    .then((response) => {
                        removeErrorList();
                        if (!response?.response?.data?.error) {
                            apiCADList()
                        } else {
                            getErrorListFromValidation(response?.response?.data?.error)
                        }
                    })
            } else {
                let body = {
                    "cadEnabled": false,
                    "cadId": cadId,
                }
                alert("Vous venez d'activer ce courrier.");
                await setCADEnabled(token, body)
                    .then((response) => {
                        removeErrorList();
                        if (!response?.response?.data?.error) {
                            apiCADList()
                        } else {
                            getErrorListFromValidation(response?.response?.data?.error)
                        }
                    })
            }
        }
    };

    const handleDeleteCAD = async (e) => {
        e.preventDefault();
        const id = e.currentTarget.getAttribute("id");
        if (!auth.roles.includes("ROLE_BACKEND")) {
            alert("Vous n'avez pas les droits pour supprimer définitivement un courrier.");
        } else {
            if (window.confirm("Êtes-vous sûr de vouloir supprimer définitivement ce courrier ?")) {
                const body = {
                    "cadId": parseInt(id),
                }
                await deleteCadFromDb(token, body)
                apiCADList()
            }
        }
    }

    const handleDeleteNetwork = async (e) => {
        e.preventDefault();
        const id = e.currentTarget.getAttribute("id");
        if (!auth.roles.includes("ROLE_BACKEND")) {
            alert("Vous n'avez pas les droits pour supprimer définitivement un réseau.");
        } else {
            if (window.confirm("Êtes-vous sûr de vouloir supprimer définitivement ce réseau ?")) {
                const body = {
                    "networkId": parseInt(id),
                }
                await deleteNetworkFromDb(token, body)
                    .then((response) => {
                        response.error ? alert("Le réseau n'a pas pu être supprimé.") : alert("Le réseau a bien été supprimé. Les agences rattachées ont été détachées.")
                    })
                apiNetworkList()
            }
        }
    }

    const handleNetworkEnable = async (e) => {
        e.preventDefault();
        if (!auth.roles.includes("ROLE_BACKEND")) {
            alert("Vous n'avez pas les droits pour modifier la visibilité d'un réseau.");
        } else {
            const networkId = parseInt(e.currentTarget.getAttribute("id"));
            const currentIsEnabled = e.currentTarget.classList.contains("fa-eye");

            if (currentIsEnabled) {
                let body = {
                    "networkEnabled": true,
                    "networkId": networkId,
                }
                alert("Vous venez de désactiver ce réseau.");
                await updateNetworkStatus(token, body)
                    .then((response) => {
                        removeErrorList();
                        if (!response?.response?.data?.error) {
                            apiNetworkList()
                        } else {
                            getErrorListFromValidation(response?.response?.data?.error)
                        }
                    })
            } else {
                let body = {
                    "networkEnabled": false,
                    "networkId": networkId,
                }
                alert("Vous venez d'activer ce réseau.");
                await updateNetworkStatus(token, body)
                    .then((response) => {
                        removeErrorList();
                        if (!response?.response?.data?.error) {
                            apiNetworkList()
                        } else {
                            getErrorListFromValidation(response?.response?.data?.error)
                        }
                    })
            }
        }
    };

    const handleDeleteDeceased = async (e) => {
        e.preventDefault();
        const id = e.currentTarget.getAttribute("id");
        if (!auth.roles.includes("ROLE_PREVIOUS_ADMIN")) {
            alert("Vous n'avez pas les droits pour supprimer définitivement un défunt.");
        } else {
            if (window.confirm("Êtes-vous sûr de vouloir supprimer définitivement ce défunt ?")) {
                const body = {
                    "deceasedId": parseInt(id),
                }
                await deleteDeceasedFromDb(token, body)
                deceasedListApi()
            }
        }
    }


        const fullRoles = {
            ROLE_PF: "PF",
            ROLE_UPF: "UPF",
            ROLE_GROUPEMENT: "Groupement",
            ROLE_BACKEND: "Backend",
        };

        const publicAssetsPath = process.env.REACT_APP_LOCAL_ASSETS_BASE_URL;

        return (
            <>
                {line
                    ? <tr className={`${deleted && "deleted"} ${isSelected}`} id={line?.id} onClick={handleClick}>

                        {(location === "Tableau de bord" || location === "Défunts") &&
                            <>
                                {thIndexes.map((idx, index) => (
                                    idx === "lastName" ?
                                        <td key={idx + index + line?.id}>{line?.lastName?.toUpperCase()}{location === "Tableau de bord" && ` ${capitalize(line?.firstName)}`}</td> :
                                    idx === "deathDateNotFormatted" ?
                                        <td key={idx + index + line?.id}>
                                            {line["deathDate"]}
                                        </td> :
                                        idx === "ceremonyDateNotFormatted" ?
                                        <td key={idx + index + line?.id}>
                                            {line["ceremonyDate"]}
                                        </td> :
                                        idx === "createdAtNotFormatted" ?
                                        <td key={idx + index + line?.id}>
                                            {line["createdAt"]}
                                        </td> :
                                    idx === "condolenceMessages" ?
                                    <td key={idx + index + line?.id}>
                                        {line["nbCondolenceMessages"]}
                                        {line["nbCondolenceMessages"] > 1 ? " messages" : " message"}
                                        {line["nbCondolenceMessagesToModerate"] > 0 && (
                                            <> (<a className="to-moderate-link" href={`/defunt/${line?.id}/condoleances/moderer`}>{line["nbCondolenceMessagesToModerate"]} à modérer</a>)</>
                                        )}
                                    </td> :
                                    <td key={idx + index + line?.id}>
                                        {line[idx]}
                                    </td>
                                ))}
                            </>
                        }

                        {location === "Activités" &&
                            <>
                                {thIndexes.map((idx, index) => (
                                    <td key={idx + index + line?.id}>
                                        {line[idx]}
                                    </td>
                                ))}
                            </>
                        }

                        {location === "Agences" &&
                            <>
                                {thIndexes.map((idx) => (
                                    idx === "name"
                                        ? <td key={'td' + idx + line?.id}>
                                            <span key={'span' + idx + line?.id}>{line[idx]}</span><br/>
                                            <p>{line?.contact ? `contact: ${line?.contact}` : null}</p>
                                            <p>{line?.manager ? `manager: ${line?.manager}` : null}</p>
                                        </td>
                                        : idx === "city"
                                            ? <td key={'td' + idx + line?.id}>
                                                <span key={'span' + idx + line?.id}>{line?.address?.address}<br/>{(line?.address?.city)?.toUpperCase()}</span><br/>
                                                {line?.address?.zipcode}
                                            </td>
                                            : idx === "activity"
                                                ? <td key={idx + line?.id}>
                                                    {line?.activity?.map((act,index) =>
                                                        <div key={index}>{act?.activityName}</div>
                                                    )}
                                                </td>
                                            : idx === "createdAtNotFormatted"
                                                ? <td key={idx + line?.id}>
                                                        {line['createdAt']}
                                                    </td>
                                                : <td key={idx + line?.id}>
                                                    {line[idx]}
                                                </td>
                                ))}
                            </>
                        }

                        {(location === "Utilisateurs") &&
                            <>
                                {thIndexes.map((idx, index) => (
                                    idx === "firstName"
                                        ? <td key={idx + index + line?.id}>
                                            <span key={idx + index + line?.id}>{line["lastName"]} {line["firstName"]}</span><br/>
                                            <span>identifiant : {line["username"]}</span><br/>
                                            <span>email : {line["email"]}</span>
                                        </td>
                                        : idx === "city"
                                            ? <td key={idx + index + line?.id}>
                                                {line[idx]}<br/>
                                                {line["zipcode"]}
                                            </td>
                                            : idx === "createdAtNotFormatted"
                                                ? <td key={idx + line?.id}>
                                                    {line['createdAt']}
                                                </td>
                                                : idx === "lastLoginNotFormatted"
                                                    ? <td key={idx + line?.id}>
                                                        {line['lastLogin']}
                                                    </td>
                                            : idx === "roles"
                                                ? <td key={idx + index + line?.id}>
                                                    {fullRoles[line?.roles]}
                                                </td>
                                                : <td key={idx + index + line?.id}>
                                                    {line[idx]}
                                                </td>
                                ))}
                            </>
                        }
                        {(location === "Agence - Utilisateurs") &&
                            <>
                                {thIndexes.map((idx, index) => (
                                    idx === "roles"
                                        ? <td key={idx + index + line?.id}>
                                            {fullRoles[line?.roles]}
                                        </td>
                                        : idx === "createdAtNotFormatted"
                                            ? <td key={idx + line?.id}>
                                                {line['createdAt']}
                                            </td>
                                            : idx === "lastLoginNotFormatted"
                                            ? <td key={idx + line?.id}>
                                                {line['lastLogin']}
                                            </td>
                                        : <td key={idx + index + line?.id}>
                                            {line[idx]}
                                        </td>
                                ))}
                            </>
                        }
                        {location === "Emails" &&
                            <>
                                {thIndexes.map((idx, index) => (
                                    idx === "description"
                                        ? <td key={idx + index + line?.id}>
                                            <span key={'desc' + idx + index + line?.id}>{line["description"]}</span><br/>
                                            <span key={'help' + idx + index + line?.id}>{line["help"]}</span>
                                        </td>
                                        : <td key={idx + index + line?.id}>
                                            {line[idx]}
                                        </td>
                                ))}
                            </>
                        }

                        {(location === "Documents" && tab === "documents") &&
                            <>
                                {thIndexes.map((idx, index) => (
                                    idx === "id"
                                        ? ""
                                        : idx === "name"
                                            ? <td className="documents-name" key={idx + index + line?.id}>
                                                <span key={'span' + idx + index + line?.id}>{line["name"]}</span><br/>
                                            </td>
                                        : idx === "description"
                                            ? <td key={idx + index + line?.id}>
                                                <TiptapView content={line?.description} />
                                            </td>
                                        : idx === "createdAtNotFormatted"
                                            ? <td key={idx + line?.id}>
                                                {line['createdAt']}
                                            </td>
                                        : idx === "updatedAtNotFormatted"
                                            ? <td key={idx + line?.id}>
                                                {line['updatedAt']}
                                            </td>
                                        : idx === "enabled"
                                            ? <td key={idx + index + line?.id}>
                                                <i
                                                    id={line?.id}
                                                    className={line?.enabled ? "fa fa-eye" : "fa fa-eye-slash"}
                                                    onClick={handleDocumentEnable}
                                                    title={line?.enabled ? "Document visible - Cliquer pour masquer" : "Document masqué - Cliquer pour rendre visible"}
                                                />
                                            </td>
                                        : idx === "url"
                                            ? <td key={idx + index + line?.id}>
                                            <a href={`${line?.url ? line?.url :`${publicAssetsPath}/documents/${line?.fileName}`}`}
                                                  target="_blank" rel="noreferrer">
                                                {line.url ? line.url : line?.fileName}
                                            </a>
                                        </td>
                                        : <td key={idx + index + line?.id}>
                                            {line[idx]}
                                        </td>

                                ))}
                            </>
                        }
                        {(location === "Documents" && tab === "devis") &&
                            <>
                                {thIndexes.map((idx, index) => (
                                    <td key={idx + index + line?.id}>
                                        {line[idx]}
                                    </td>
                                ))}
                            </>
                        }
                        {location === "Devis" &&
                            <>
                                {thIndexes.map((idx, index) => (
                                    idx === "tvaRate" ?
                                        <td key={idx + index + line?.id}>
                                            {line[idx] === 1 ? "0.00%" : line[idx] === 2 ? "3.00%" : line[idx] === 3 ? "20.00%" : ""}
                                        </td> :
                                    idx === "sectionLine"
                                        ? <td key={index}>{line?.sectionLine}</td>
                                        : idx === "enabled"
                                        ? <td key={idx + index + line?.id}>
                                            <i
                                                id={line?.id}
                                                className={line["lineEnabled"] ? "fa fa-eye" : "fa fa-eye-slash"}
                                                onClick={handleEstimateLineEnable}
                                                title={line["lineEnabled"] ? "Ligne visible - Cliquer pour masquer" : "Ligne masquée - Cliquer pour rendre visible"}
                                            />
                                        </td>
                                        : idx === "description"
                                                ? <td key={idx + index + line?.id}>{line?.description}<br/>{line?.comment} </td>
                                        : idx === "dataInput"
                                        ? <td key={index}><input type="checkbox" disabled="disabled" defaultChecked={line?.dataInput}/> </td>
                                        : idx === "usualAvailable"
                                        ? <td key={index}><input type="checkbox" disabled="disabled" defaultChecked={line?.usualAvailable}/> </td>
                                        : idx === "complementaryAvailable"
                                        ? <td key={index}><input type="checkbox" disabled="disabled" defaultChecked={line?.complementaryAvailable}/> </td>
                                        : idx === "familyFeeAvailable"
                                        ? <td key={index}><input type="checkbox" disabled="disabled" defaultChecked={line?.familyFeeAvailable}/> </td>
                                                    :<td key={idx + index + line?.id}>
                                            {line[idx]}
                                        </td>
                                ))}
                            </>
                        }
                        {(location === "Catégories") &&
                            <>
                                {thIndexes.map((idx, index) => (
                                    (idx === "enabled")
                                        ? <td key={index} className="actions">
                                            <i id={line?.id} className="fa fa-pen-to-square"/>
                                            <i
                                                id={line?.id}
                                                className={line["enabled"] ? "fa fa-eye" : "fa fa-eye-slash"}
                                                title={line["enabled"] ? "Catégorie visible - Cliquer pour masquer" : "Catégorie masquée - Cliquer pour rendre visible"}
                                            />
                                        </td>
                                        : <td key={idx + index + line?.id}>
                                            <span>{line[idx]}</span>
                                        </td>
                                ))}
                            </>
                        }

                        {location === "Courriers après décès" &&
                            <>
                                {thIndexes.map((idx, index) => (
                                    (idx === "id") ?
                                    <td key={idx + index + line?.id}>
                                        {line['number']}
                                    </td> :
                                (idx === "description") ?
                                    <td key={idx + index + line?.id}>
                                        <TiptapView content={line["description"]} />
                                    </td> :
                                    idx === "createdAtNotFormatted"
                                    ? <td key={idx + line?.id}>
                                        {line['createdAt']}
                                    </td>:
                                    <td key={idx + index + line?.id}>
                                        {line[idx]}
                                    </td>
                                ))}
                            </>
                        }
                        {(location === "Réseaux") &&
                            <>
                                {thIndexes.map((idx, index) => (
                                    idx === "createdAtNotFormatted"
                                    ? <td key={idx + line?.id}>
                                        {line['createdAt']}
                                    </td>
                                    : <td key={idx + index + line?.id}>
                                        {line[idx]}
                                    </td>
                                ))}
                            </>
                        }

                        {location === "Tableau de bord" &&
                            <td key={'td-actions' + line?.id} className="actions">
                                <div>
                                    <Link key={'link-deceased-' + line?.id} to={`/defunt/${line?.id}`} title="Voir le défunt"><i
                                        className="fa fa-gear"></i></Link>
                                    {auth.roles.includes("ROLE_PREVIOUS_ADMIN") &&
                                        <i id={line?.id} className="fa fa-trash" onClick={handleDeleteDeceased} title="Supprimer définitivement le défunt"></i>
                                    }
                                    <i
                                        id={line?.id}
                                        className={line["isListed"] ? "fa fa-eye" : "fa fa-eye-slash"}
                                        onClick={handleChangeDeceasedEnabled}
                                        title={line["isListed"] ? "Défunt visible - Cliquer pour masquer" : "Défunt masqué - Cliquer pour rendre visible"}
                                    />
                                </div>

                            </td>
                        }

                        {location === "Activités" &&
                            <td className="actions">
                                <div>
                                    <Link key={'link-edit-' + line?.id} to={`${line?.id}/modifier`} title="Modifier l'activité"><i
                                        className="fa fa-pen-to-square"></i></Link>
                                    {auth.roles.includes("ROLE_BACKEND") &&
                                        <Link id={line?.id} key={'link-delete-' + line?.id} to={`${line?.id}/supprimer`}
                                              onClick={handleDeleteActivity} title="Supprimer définitivement l'activité"><i className="fa fa-trash"></i></Link>
                                    }
                                    <i
                                        id={line?.id}
                                        className={line["activityEnabled"] ? "fa fa-eye" : "fa fa-eye-slash"}
                                        onClick={handleChangeActivityEnabled}
                                        title={line["activityEnabled"] ? "Activité visible - Cliquer pour masquer" : "Activité masquée - Cliquer pour rendre visible"}
                                    />
                                </div>
                            </td>
                        }

                        {location === "Documents" &&
                            <td className="actions">
                                <div>
                                    <Link key={'link-edit-' + line?.id} to={`${line?.id}/voir`} title="Voir le document"><i
                                        className="fa fa-gear"></i>
                                    </Link>
                                    {auth.roles.includes("ROLE_BACKEND") &&
                                        <Link id={line?.id} key={'link-delete-' + line?.id}
                                              to={`${line?.id}/supprimer`}
                                              title="Supprimer définitivement le document"
                                              onClick={handleDeleteDocument}>
                                            <i className="fa fa-trash"></i>
                                        </Link>
                                    }
                                    <i
                                        id={line?.id}
                                        className={line?.enabled ? "fa fa-eye" : "fa fa-eye-slash"}
                                        onClick={handleDocumentEnable}
                                        title={line?.enabled ? "Document visible - Cliquer pour masquer" : "Document masqué - Cliquer pour rendre visible"}
                                    />
                                </div>
                            </td>

                        }
                        {location === "Agences" &&
                            <td className="actions">
                                <div>
                                    <Link to={`${line?.id}/voir`} title="Voir l'agence"><i
                                        className="fa fa-gear"></i></Link>
                                    {auth?.roles.includes("ROLE_BACKEND") &&
                                        <i id={line?.id} className="fa fa-trash" onClick={handleDeleteAgency} title="Supprimer définitivement l'agence"/>
                                    }
                                    <i
                                        id={line?.id}
                                        className={line["agencyEnabled"] ? "fa fa-eye" : "fa fa-eye-slash"}
                                        onClick={handleAgencyEnable}
                                        title={line["agencyEnabled"] ? "Agence visible - Cliquer pour masquer" : "Agence masquée - Cliquer pour rendre visible"}
                                    />
                                </div>

                            </td>
                        }
                        {location === "Emails" &&
                            <td className="actions">
                                <div>
                                    <Link to={`${line?.id}/voir`} title="Voir l'email"><i className="fa fa-gear"></i></Link>
                                </div>
                            </td>
                        }
                        {location === "Utilisateurs" &&
                            <td className="actions">
                                <div>
                                    <Link to={`${line?.id}/voir`} title="Voir l'utilisateur"><i
                                        className="fa fa-gear"></i></Link>
                                    {auth.roles.includes("ROLE_BACKEND") && (line?.roles?.includes("ROLE_PF") || line?.roles?.includes("ROLE_UPF")) && line?.enabled &&
                                        <i className="fa fa-arrows-rotate" onClick={() => handleSwitchUser(line?.username)} title="Se connecter en tant que" />
                                    }
                                    {auth.roles.includes("ROLE_BACKEND") &&
                                        <Link className="users" id={line?.id} key={'link-delete-' + line?.id}
                                              to={`${line?.id}/supprimer`}
                                              title="Supprimer définitivement l'utilisateur"
                                              onClick={handleDeleteUser}><i className="fa fa-trash"></i>
                                        </Link>
                                    }
                                    <i
                                        id={line?.id}
                                        className={line["enabled"] ? "fa fa-eye" : "fa fa-eye-slash"}
                                        onClick={handleChangeUserEnabled}
                                        title={line["enabled"] ? "Utilisateur actif - Cliquer pour désactiver" : "Utilisateur inactif - Cliquer pour activer"}
                                    />
                                </div>
                            </td>
                        }
                        {location === "Devis" &&
                             <td className="actions">
                                 <div>
                                     <i id={line?.id} key={'link-edit-' + line?.id}
                                        className="fa fa-pen-to-square edit-estimate-line"
                                        title="Modifier la ligne de devis"></i>
                                     {auth.roles.includes("ROLE_BACKEND") &&
                                         <Link id={line?.id} key={'link-delete-' + line?.id} to={`${line?.id}/supprimer`}
                                               onClick={handleDeleteEstimateLine} title="Supprimer le devis"><i className="fa fa-trash"></i></Link>
                                     }
                                 </div>
                             </td>
                        }
                        {location === "Courriers après décès" &&
                             <td className="actions">
                                 <div>
                                     <Link key={'link-view-' + line?.id} to={`${line?.id}/voir`} title="Voir le courrier">
                                     <i className="fa fa-gear"/></Link>
                                 { auth.roles.includes("ROLE_BACKEND") &&
                                     <i id={line?.id} className="fa fa-trash" onClick={handleDeleteCAD} title="Supprimer définitivement le courrier"></i>
                                 }
                                     <i
                                         id={line?.number}
                                         className={line?.cadEnabled ? "fa fa-eye" : "fa fa-eye-slash"}
                                         onClick={handleCadExpressEnable}
                                         title={line?.cadEnabled ? "Courrier visible - Cliquer pour masquer" : "Courrier masqué - Cliquer pour rendre visible"}
                                     />
                                 </div>
                             </td>
                        }
                         {location === "Réseaux" &&
                             <td className="actions">
                                 <div>
                                 <Link id={line?.id} to={`/admin/reseaux/${line?.id}/voir`} title="Voir le réseau"><i
                                     className="fa fa-gear"></i>
                                 </Link>
                                 {auth.roles.includes("ROLE_BACKEND") &&
                                     <Link id={line?.id} key={'link-delete-' + line?.id} to={`${line?.id}/supprimer`}
                                           onClick={handleDeleteNetwork} title="Supprimer le réseau"><i className="fa fa-trash"></i>
                                     </Link>
                                 }
                                     <i
                                         id={line?.id}
                                         className={line?.enabled ? "fa fa-eye" : "fa fa-eye-slash"}
                                         onClick={handleNetworkEnable}
                                         title={line?.enabled ? "Réseau visible - Cliquer pour masquer" : "Réseau masqué - Cliquer pour rendre visible"}
                                     />
                                 </div>
                             </td>
                         }
                    </tr>
                    : "Pas de données à afficher"
                }
            </>
        )
}
